module.exports = __webpack_public_path__ + "img/jason-head-min.a9213d35.jpg";